// Light / Dark / Match device switch for the creator app's theme.
// Used on /profile (Appearance card) and in the Navbar account menu.
import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useThemePreference } from '../../theme/creatorTheme';

const OPTIONS = [
  { value: 'light', label: 'Light', Icon: Sun },
  { value: 'dark', label: 'Dark', Icon: Moon },
  { value: 'system', label: 'Device', Icon: Monitor },
];

const ThemeSwitch = ({ compact = false }) => {
  const [pref, setPref] = useThemePreference();
  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className={`inline-flex w-full rounded-xl bg-gray-100 p-1 ${compact ? '' : 'max-w-sm'}`}
    >
      {OPTIONS.map(({ value, label, Icon }) => {
        const on = pref === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => setPref(value)}
            className={`flex-1 flex items-center justify-center gap-1.5 rounded-lg font-medium transition-colors ${
              compact ? 'py-1.5 text-xs' : 'py-2 text-sm'
            } ${on ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-800'}`}
          >
            <Icon className={compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} />
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default ThemeSwitch;
